export function defaultString(value: string | undefined, fallback: string) {
  if (value == null || value.trim().length === 0) {
    return fallback;
  }
  return value;
}
